import { createClient, HttpError } from "@/http/lib";
import { apiBaseUrl } from "../config";

export const noAuthApi = createClient({
  baseURL: apiBaseUrl,
});

noAuthApi.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(new HttpError(error))
);

noAuthApi.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(new HttpError(error));
  }
);
